import React from "react";
import PropTypes from "prop-types";
import "../css/Hero.css";
import Image from "./Image";

/**
 * Hero component
 */
class Hero extends React.Component {
  static displayName = "Hero";
  static propTypes = {
    className: PropTypes.string,
    isHeader: PropTypes.boolean,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Hero";
  }

  /**
   * @override
   */
  render() {
    return (
      <div
        className={`${this.className} ${this.props.className || ""} ${
          this.props.isHeader ? "header" : ""
        }`}
      >
        <Image
          src={this.props.imageSrc}
          alt="Hero"
          className={`${this.className}__image`}
        />
        {/* <div className={`${this.className}__content`}>
          <div className={`${this.className}__text content`}>
            <div
              className={`${this.className}__html`}
              dangerouslySetInnerHTML={{ __html: this.props.content }}
            />
            {this.props.children}
          </div>
        </div> */}
      </div>
    );
  }
}

export default Hero;



// WEBPACK FOOTER //
// ./src/components/Hero.js